import React from 'react';

import { mergeStyleSets, ITag, IBasePickerProps, IDropdownOption, IconButton, Dropdown } from '@fluentui/react';

import { IChoiceField, IField, ILookupField } from '../../../shared/interfaces';
import { Indici_FormMode, Search_QueryOperator } from '../../../shared/enums';
import AppUtilities from '../../../shared/Utilities/appUtilities';
import Autocomplete from './Autocomplete';
import ArxeiaLabel from '../ArxeiaLabel';


const classNames = mergeStyleSets({
    inputWrapper:
    {
        paddingBottom: '20px',

    }
});


export interface MyDropdownHandle {
}

export interface MyDropdownProps {
    formMode?: Indici_FormMode
    field: IField
    autofocus?: boolean,
    changed: (newField: IField) => void
}


const MyDropdown: React.ForwardRefRenderFunction<MyDropdownHandle, MyDropdownProps> = (props, ref) => {

    const choicefield = props.field as IChoiceField
    choicefield.search_QueryOperator = Search_QueryOperator.Equals;

    var choiceOptions: IDropdownOption[] = choicefield.options as IDropdownOption[];

    const inputChanged = (newField: IField) => {
        props.changed({ ...newField, valid: AppUtilities.checkFieldValidity(newField), touched: true })
    }


    let onSelectChange = (event: React.FormEvent<HTMLDivElement>, option?: IDropdownOption, index?: number) => {
        if (choicefield.multi) {
            let selectedValues = choicefield.internalValue ? choicefield.internalValue : [];
            if (selectedValues.findIndex(el => el === option?.key) < 0) {
                inputChanged({ ...choicefield, internalValue: [...selectedValues, option?.key] })
            }
            else {
                let newSelectedValues = selectedValues.filter(el => el !== option?.key)
                inputChanged({ ...choicefield, internalValue: [...newSelectedValues] })

            }
        }
        else {
            inputChanged({ ...choicefield, internalValue: option?.key })
        }
    }

    let onCleanDropdownButton = (ev: any) => {
        ev.preventDefault();
        ev.stopPropagation();
        inputChanged({ ...choicefield, internalValue: null });
    }

    const onRenderTitle = (options: IDropdownOption<any>[] | undefined): JSX.Element => {
        const option = options![0];

        return (
            <div>
                <span>{option.text} <IconButton iconProps={{ iconName: 'Cancel' }} styles={{ root: { height: 20, width: 20, verticalAlign: 'text-top' } }} onClick={onCleanDropdownButton} /></span>
            </div>
        );
    };
    if (props.formMode !== Indici_FormMode.Search || choicefield.internalName === 'StatoProtocollo' || choicefield.internalName === 'TipoProtocollo' || choicefield.internalName === 'Priorita') {
        return (
            <div className={classNames.inputWrapper}>
                <div className={choicefield.touched && !choicefield.valid ? 'field error' : 'field'}>
                    <ArxeiaLabel field={choicefield} />

                    <Dropdown
                        key={choicefield.internalName}
                        disabled={false}
                        placeholder="Seleziona un elemento"
                        options={choiceOptions}
                        selectedKey={!choicefield.multi ? choicefield.internalValue : undefined}
                        selectedKeys={choicefield.multi ? choicefield.internalValue : undefined}
                        multiSelect={choicefield.multi}
                        onChange={onSelectChange}
                        onRenderTitle={!choicefield.multi ? onRenderTitle : undefined}
                    />
                    {choicefield.touched && !choicefield.valid && <span className="error-message">Campo obbligatorio</span>}

                </div >
            </div >

        );


    }
    else {
        let newfield = { ...props.field } as ILookupField;
        let choiceOptionsAsTagArray: ITag[] = choiceOptions.map(el => {
            return { key: el.key, name: el.text }
        });
        newfield.basePickerProps = {
            onResolveSuggestions: async (searchValue: string, currentTags?: ITag[]): Promise<ITag[]> => {
                let result: ITag[] = choiceOptionsAsTagArray.filter(el => el.key.toString().toLowerCase().includes(searchValue.toLowerCase()));
                if (currentTags) {
                    //Rimuovo eventuali elementi già selezionati
                    result = result.filter(persona => currentTags.findIndex(el => el.key === persona.key) < 0);
                }
                return result;
            },
            onEmptyResolveSuggestions: () => [...choiceOptionsAsTagArray]
        } as IBasePickerProps<ITag>;
        

        return <Autocomplete {...props} field={newfield} />
    }
};


const ForwardedMyDropdown = React.forwardRef(MyDropdown);
export default ForwardedMyDropdown;







